module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "toolbar"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isshowgift),
      expression: "isshowgift"
    }],
    staticClass: "zanBtn fl",
    attrs: {
      "src": "https://res-live.tenghuiwangxiao.cn/web/wx-user/wechatlive/img/v_songhua.png"
    },
    on: {
      "click": function($event) {
        return _vm.sendFllowerTap(1)
      }
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isshowgift),
      expression: "isshowgift"
    }],
    staticClass: "zanBtn fl",
    attrs: {
      "src": "https://res-live.tenghuiwangxiao.cn/web/wx-user/wechatlive/img/v_dianzan.png"
    },
    on: {
      "click": function($event) {
        return _vm.sendFllowerTap(2)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "comment"
  }, [_c('div', {
    staticClass: "inputValue",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showcommentBox.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.placeholder))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://res-live.tenghuiwangxiao.cn/web/wx-user/wechatlive/img/Vertical/send.png"
    },
    on: {
      "click": _vm.sendMsg
    }
  })])]), _vm._v(" "), _c('van-popup', {
    staticClass: "iosPosition",
    model: {
      value: (_vm.commentBox),
      callback: function($$v) {
        _vm.commentBox = $$v
      },
      expression: "commentBox"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    staticClass: "textarea",
    attrs: {
      "placeholder": _vm.placeholder,
      "cols": "30",
      "rows": "5"
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.sendMsg.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btnBox"
  }, [_c('a', {
    staticClass: "btn",
    on: {
      "click": _vm.showcommentBox
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    on: {
      "click": _vm.sendMsg
    }
  }, [_vm._v("发送")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e9c0f32"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/Vertical/toolbar.vue
// module id = 521
// module chunks = 0